export const yupLocale = {
    mixed: {
        default: {
            key: 'validations.invalid',
        },
        required: {
            key: 'validations.required',
        },
        notType: ({ type }: { type: string }) => ({
            key: 'validations.invalidType',
            values: { type },
        }),
        oneOf: ({ values }: { values: Array<string | number> }) => ({
            key: 'validations.oneOf',
            values: { values },
        }),
    },
    string: {
        email: {
            key: 'validations.email',
        },
        min: ({ min }: { min: number }) => ({
            key: 'validations.stringMin',
            values: { min },
        }),
        max: ({ max }: { max: number }) => ({
            key: 'validations.stringMax',
            values: { max },
        }),
        matches: ({ regex }: { regex: RegExp }) => {
            switch (regex.toString()) {
                case '/[A-Z]/':
                    return {
                        key: 'validations.passwordUpperCase',
                    }
                case '/[a-z]/':
                    return {
                        key: 'validations.passwordLowerCase',
                    }
                case '/[0-9]/':
                    return {
                        key: 'validations.passwordNumber',
                    }
                case '/[@$!%*#?&]/':
                    return {
                        key: 'validations.passwordSpecial',
                    }
                default:
                    return {
                        key: 'validations.invalid',
                    }
            }
        },
    },
    number: {
        min: ({ min }: { min: number }) => ({
            key: 'validations.numberMin',
            values: { min },
        }),
        max: ({ max }: { max: number }) => ({
            key: 'validations.numberMax',
            values: { max },
        }),
    },
    boolean: {},
}
